t<template>
    <page style="background: #fff">
        <c-form ref="form">
            <c-form-item label="紧急程度" required>
                <c-radio-group name="emergency_level" :options="orderUrgencyDic"></c-radio-group>
            </c-form-item>
            <c-form-item label="请假类型" required>
                <c-select name="leave_type" :options="leaveTypeDic" @change="onLeaveTypeChange"></c-select>
            </c-form-item>
            <c-tips v-if="showBalance && leaveBalance !== null">当前余额：{{leaveBalance}}{{currentUnit == 2 ? '小时' : '天'}}</c-tips>
            <c-form-item label="开始时间" required>
                <c-datetime v-model="startTime" type="datetime" name="start_time" format="yyyy-MM-dd hh:mm" time-accuracy="min" @change="updateLength('startTime')"></c-datetime>
            </c-form-item>
            <c-form-item label="结束时间" required>
                <c-datetime v-model="endTime" type="datetime" name="end_time" format="yyyy-MM-dd hh:mm" time-accuracy="min" @change="updateLength('endTime')"></c-datetime>
            </c-form-item>

            <c-form-item label="请假时长" required >
                <c-input v-model="leaveDuration" type="number" name="leave_duration" v-bind="durationProps" :disabled="currentUnit == 2" :append-text="currentUnit == 2 ? '小时' : '天'"></c-input>
            </c-form-item>
            <c-form-item label="请假事由">
                <c-input type="textarea" name="reason"></c-input>
            </c-form-item>
            <c-form-item label="图片">
                <c-upload-file name="attachment_images" type="image" multiple="9" media></c-upload-file>
            </c-form-item>

            <doc-flow ref="flow" flow="4"></doc-flow>
        </c-form>

        <template #button>
            <c-button size="form" @click="submitHandle(-1)">暂存</c-button>
            <c-button size="form" color="main" @click="submitHandle(1)">确认提交</c-button>
        </template>
    </page>
</template>

<script>	import {mapState} from 'vuex';

export default {
    props: {
        id: String
    },

    data() {
        return {
            leaveBalance: null,
            startTime: '',
            endTime: '',
            currentLeaveType: '',
            leaveDuration: '',
        }
    },

    computed: {
        ...mapState(['orderUrgencyDic', 'leaveTypeDic', 'timePeriodDic']),

        currentUnit() {
            let match = this.leaveTypeDic.find(item => item.value == this.currentLeaveType);
            return match ? match.leave_granularity : 1;
        },

        showBalance() {
            return [3, 8].includes(Number(this.currentLeaveType));
        },

        durationProps() {
            if (this.currentUnit == 2) {
                return { decimal: '1', range: [0.5, 999] };
            }
            return { decimal: '1', range: [0.5] };
        },

        submitRule() {
            let rule = {
                emergency_level: '请选择紧急程度',
                leave_type: '请选择请假类型',
                leave_duration: data => {
                    if (this.currentUnit != 1) return true;
                    let duration = parseFloat(data.leave_duration);
                    if (isNaN(duration) || duration < 0.5 || duration % 0.5 !== 0) {
                        return '请假时长须为0.5天的倍数';
                    }
                    return true;
                },
                start_time: '请填写开始时间',
                end_time: '请填写结束时间'
            };
            return rule;
        }
    },

    mounted() {
        if (this.id) {
            this.request({
                url: '/leave/application/detail',
                data: {
                    id: this.id
                },
                success: ({detailInfo}) => {
                    this.workOrderId = detailInfo.apply_id;
                    this.$refs.form.set(detailInfo);
                    this.currentLeaveType = detailInfo.leave_type;
                    this.startTime = detailInfo.start_time;
                    this.endTime = detailInfo.end_time;
                    this.leaveDuration = detailInfo.leave_duration;
                    if (this.showBalance) {
                        this.queryBalance(detailInfo.leave_type);
                    }
                }
            })
        } else {
            this.$refs.form.set({
                emergency_level: 1
            })
        }
    },

    methods: {
        onLeaveTypeChange(val) {
            this.currentLeaveType = val.value;
            this.leaveBalance = null;
            if ([3, 8].includes(Number(val.value))) {
                this.queryBalance(val.value);
            }
            this.clearTimeFields();
        },

        clearTimeFields() {
            this.startTime = '';
            this.endTime = '';
            this.leaveDuration = '';
            this.$refs.form.set({ leave_duration: '' });
        },

        queryBalance(leaveType) {
            this.request({
                url: '/leave/balance/query',
                data: {
                    leave_type: leaveType
                },
                success: (data) => {
                    this.leaveBalance = 0;
                    if(data){
                        this.leaveBalance = data.remaining_amount||0;
                    }
                }
            });
        },

        updateLength(type) {
            this.$nextTick(() => {
                let start = new Date(this.startTime.replace(/-/g, '/'));
                let end = new Date(this.endTime.replace(/-/g, '/'));
                if (start.getTime() && end.getTime()) {
                    if (end <= start) {
                        this.$message({ message: '开始时间需早于结束时间' });
                        this.$nextTick(() => { this[type] = ''; });
                    } else if (this.currentUnit == 2) {
                        this.calcDuration({
                            start_time: this.startTime,
                            end_time: this.endTime
                        });
                    }
                }
            });
        },

        calcDuration(params) {
            this.request({
                url: '/leave/application/calcDuration',
                data: {
                    leave_type: this.currentLeaveType,
                    ...params
                },
                success: (data) => {
                    this.$refs.form.set({ leave_duration: data.leave_duration });
                    this.leaveDuration = data.leave_duration;
                }
            });
        },

        submitHandle(state) {
            this.$refs.form.submit({
                url: this.id ? '/leave/application/update' : '/leave/application/add',
                rule: this.submitRule,
                dataFormatter: data => {
                    data.id = this.id;
                    data.status = state;
                    data.attachment_images = data.attachment_images ? data.attachment_images.join(',') : '';
                    data.start_time = this.startTime;
                    data.end_time = this.endTime;
                    return data;
                },
                success: (data, res) => {
                    this.$refs.flow.apply(state, res.transaction, () => {
                        this.$message({
                            message: '提交成功',
                            mask: true
                        });
                        setTimeout(() => {
                            if (this.id) {
                                this.mp.navigateBack();
                            } else {
                                this.mp.redirectWeb('/affairs/leave/detail', {id: res.detailInfo.id});
                            }
                        }, 1000);
                    });
                }
            })
        }
    }
}
</script>

<style lang="stylus" scoped></style>